module.exports = __webpack_public_path__ + "static/media/phone_thumb.210a5c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/phone_thumb.png
// module id = 294
// module chunks = 0